customElements.define("product-custom-variation", class ProductCustomVariation extends HTMLElement {
    constructor(){
        super();
        this.querySelector("select").addEventListener("change", this.handleChange.bind(this));
    }

    handleChange(e){
        window.location.href = e.currentTarget.value;
    }

});